export const popoverTheme = {
  root: {
    borderRadius: 'var(--border-radius)',
  },
  content: {
    padding: 'var(--rem)',
  },
  colorScheme: {
    light: {
      root: {
        background: 'var(--p-white)',
        shadow: 'var(--dialog-box-shadow)',
      },
    },
    dark: {
      root: {
        background: 'var(--secondary-background)',
        shadow: 'var(--dialog-box-shadow)',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-popover:after, .p-popover:before {
    visibility: hidden;
  }
  `,
};
